module.exports = __webpack_public_path__ + "img/banner14.adbcac78.png";